import { forwardRef } from "react";
import { Box } from "../../primitives/box";
import type { ButtonProps } from "./types";
import { Spinner } from "../spinner";
import { useButtonStyles } from "./styles";

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      children,
      variant = "primary",
      size = "md",
      shape = "rounded",
      disabled = false,
      isLoading = false,
      onPress,
      leftIcon,
      rightIcon,
      backgroundColor,
      textColor,
      height,
      ...rest
    },
    ref,
  ) => {
    const isDisabled = disabled || isLoading;
    const styles = useButtonStyles(
      variant,
      size,
      shape,
      isDisabled,
      backgroundColor,
      textColor,
      height,
    );

    return (
      <Box
        as="button"
        ref={ref}
        type="button"
        disabled={isDisabled}
        alignItems="center"
        justifyContent="center"
        gap="s"
        onClick={(e) => {
          if (isDisabled) {
            e.preventDefault();
            return;
          }
          onPress?.();
        }}
        style={styles.container}
        {...rest}
      >
        {isLoading ? (
          <Spinner size="sm" color={styles.spinnerColor} />
        ) : (
          <>
            {leftIcon && <Box alignItems="center">{leftIcon}</Box>}
            {children && (
              <Box alignItems="center" style={{ color: textColor }}>
                {children}
              </Box>
            )}
            {rightIcon && <Box alignItems="center">{rightIcon}</Box>}
          </>
        )}
      </Box>
    );
  },
);

Button.displayName = "Button";
